// extracted by mini-css-extract-plugin
module.exports = {"viewport":"k4my9smxYpwDKaNhhTJU-g=="};